'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiLinkOutline = function TiLinkOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.2 10c0.4 0 0.9 0.2 1.3 0.5 0.7 0.8 0.7 1.9 0 2.6l-2.9 2.9 0.5 0.5c1 1 1.5 2.3 1.5 3.7s-0.5 2.6-1.5 3.6l-6.9 7c-1 0.9-2.3 1.5-3.7 1.5s-2.7-0.6-3.7-1.5l-0.5-0.5-2.8 2.8c-0.4 0.4-0.9 0.6-1.3 0.6s-1-0.2-1.3-0.6c-0.7-0.7-0.7-1.8 0-2.6l2.8-2.8-0.5-0.5c-0.9-1-1.5-2.3-1.5-3.7s0.6-2.7 1.5-3.7l7-6.9c1-1 2.3-1.5 3.6-1.5s2.7 0.5 3.7 1.5l0.5 0.5 2.9-2.9c0.3-0.3 0.8-0.5 1.3-0.5z m0-3.3c-1.4 0-2.7 0.5-3.7 1.5l-0.8 0.8c-1.2-0.6-2.5-0.9-3.9-0.9-2.2 0-4.4 0.9-6 2.4l-6.9 7c-1.6 1.6-2.5 3.7-2.5 6 0 1.4 0.3 2.7 0.9 3.9l-0.8 0.8c-1 1-1.5 2.2-1.5 3.6 0 1.4 0.5 2.7 1.5 3.7 1 1 2.3 1.5 3.7 1.5s2.6-0.5 3.6-1.5l0.8-0.8c1.2 0.6 2.5 0.9 3.9 0.9 2.3 0 4.4-0.9 6-2.5l7-6.9c1.6-1.6 2.4-3.8 2.4-6 0-1.4-0.3-2.7-0.9-3.9l0.8-0.8c1-1 1.5-2.3 1.5-3.7 0-1.3-0.5-2.6-1.5-3.6-1-1-2.3-1.5-3.6-1.5z m-10.2 11.9c0 0.9 0.4 1.7 1 2.4 0.7 0.6 1.5 1 2.4 1l-3.1 3c0-0.8-0.4-1.7-1-2.3-0.6-0.6-1.5-1-2.4-1l3.1-3.1z m1.8-3.6c-0.4 0-0.7 0.2-1 0.5l-7 6.9c-0.3 0.3-0.4 0.7-0.4 1.1 0 0.4 0.1 0.8 0.4 1.1l0.5 0.5 1.2-1.2c0.4-0.4 0.9-0.6 1.3-0.6s1 0.2 1.3 0.6c0.7 0.7 0.7 1.8 0 2.6l-1.2 1.2 0.5 0.5c0.3 0.3 0.7 0.4 1.1 0.4s0.8-0.1 1.1-0.4l6.9-7c0.3-0.3 0.5-0.6 0.5-1 0-0.4-0.2-0.8-0.5-1.1l-0.5-0.5-1.2 1.2c-0.4 0.4-0.8 0.5-1.3 0.5s-0.9-0.1-1.3-0.5c-0.7-0.7-0.7-1.9 0-2.6l1.2-1.2-0.5-0.5c-0.3-0.3-0.7-0.5-1.1-0.5z' })
        )
    );
};

exports.default = TiLinkOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/link-outline.js
// module id = 3639
// module chunks = 0